"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpLibraryTabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var DpNavigationTabs_1 = __importDefault(require("../../NavigationTabs/DpNavigationTabs"));
var router_1 = require("next/router");
var LIBRARY_TAB = 'library';
var ASSESSMENTS_TAB = 'assessments';
var DpLibraryTabs = function (_a) {
    var selectedTab = _a.selectedTab, showMyAssessmentsTab = _a.showMyAssessmentsTab;
    // ------------------------------- State & Hooks
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var router = (0, router_1.useRouter)();
    // ------------------------------- Events
    var selectTab = function (tab) {
        router.push(tab.id === LIBRARY_TAB ? '/library' : '/library/my-assessments');
    };
    // ------------------------------- Render
    var navigationTabs = [
        {
            id: LIBRARY_TAB,
            label: t('DpLibraryTabs.gm'),
            active: selectedTab === LIBRARY_TAB,
        },
    ];
    if (showMyAssessmentsTab) {
        navigationTabs.push({
            id: ASSESSMENTS_TAB,
            label: t('DpLibraryTabs.assessments'),
            active: selectedTab === ASSESSMENTS_TAB,
        });
    }
    return (0, jsx_runtime_1.jsx)(DpNavigationTabs_1.default, { elements: navigationTabs, selectionHandler: selectTab });
};
exports.DpLibraryTabs = DpLibraryTabs;
exports.default = exports.DpLibraryTabs;
